import React from 'react';
import useWidth from '@/helpers/widthUtil';

const AbroadPerks = () => {
  const { isMobile } = useWidth();

  return (
    <div className="pl-md-3 pr-md-3 mt-4 institution-items w-100 ">
      <div className="row w-100 ">
        {items.map((i, idx) => (
          <ItemCard key={idx} {...i} isMobile={isMobile} />
        ))}
      </div>
    </div>
  );
};

export default AbroadPerks;

const items = [
  {
    img: '/images/abroad/easy-application.svg',
    title: 'Easy Application',
    description:
      'Apply to multiple program and college options with your own profile',
  },
  {
    img: '/images/abroad/counsel.svg',
    title: 'Admission Counselling',
    description:
      'Advise and thorough counselling from experts throughout the process',
  },
  {
    img: '/images/abroad/finance.svg',
    title: 'Financial guidance',
    description:
      'Get assistance to finding scholarships and financial support options',
  },
  {
    img: '/images/abroad/visa.svg',
    title: 'Visa assistance',
    description: 'Get expert’s support for hassle free visa process',
  },
];

const ItemCard = ({ img, title, description, isMobile }) => {
  return (
    <div
      className={`item-card rounded bordered shadow col-lg-5 col-md-5 col-sm-12 trm-hv text-center py-3 ${
        isMobile ? 'm-3' : ''
      }`}
    >
      <img src={img} alt={title} height={90} width={90} />
      <span className="detail">{title}</span>
      <span className="">{description}</span>
    </div>
  );
};
